import store from 'store/store';
import { signIn } from 'store/ducks/auth/actions';
import { history } from 'routes/history';
import { updateProfile } from 'store/ducks/user/actions';
import { getLangs } from 'store/ducks/langs/actions';

const appConfig = () => {
	const token = localStorage.getItem('accessToken');
	const user = localStorage.getItem('user');
	if (!token || !user) return history.push('/');
	store.dispatch(signIn(token));
	store.dispatch(updateProfile(JSON.parse(user)));
	store.dispatch(getLangs());
};

export default appConfig;
